













































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignContactDto from '@/models/CampaignContacts/CampaignContactDto';
import CampaignContact from '@/components/CampaignContacts/CampaignContact.vue'
import CampaignContactStatus from '@/components/CampaignContacts/Display/CampaignContactStatus.vue'
import CampaignContactStatusEnum from '@/models/CampaignContacts/CampaignContactStatus';

@Component({
  name: 'CampaignContacts',
  components: { CampaignContact, CampaignContactStatus }
})
export default class extends GiganautVue {

	campaignContactStatusEnum = CampaignContactStatusEnum;
	page = 1;
	perPage = 8;

	get selectedCampaignContact() {
		return CampaignDetailsModule.campaignContactsVM.selectedCampaignContact;
	}

	set selectedCampaignContact(value: CampaignContactDto) {
		CampaignDetailsModule.campaignContactsVM.selectedContactId = value.contactId;
		CampaignDetailsModule.campaignContactsVM.selectedCampaignContact = value;
	}
	
	get campaignContacts() {
		return CampaignDetailsModule.campaignContactsVM.campaignContacts;
	}

	get pagedCampaignContacts() {
		return this.campaignContacts.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}
	
	async onPageChanged(input: number){
		CampaignDetailsModule.campaignContactsVM.selectedCampaignContact = (this.pagedCampaignContacts[0]);
	}

	get loadingContacts() {
		return CampaignDetailsModule.loadingContacts;
	}

	async updateSelectedContactIds(val: boolean, workerId: string) {
    	if (val) {
			//await CampaignDetailsModule.addBrowseSelectedContactId(contactProfileId)
		} else {
			//await CampaignDetailsModule.removeBrowseSelectedContactId(contactProfileId)
		}
	}
}
